module.exports = __webpack_public_path__ + "img/1970East-024_WEB-min.40abfc68.jpg";